module.exports = __webpack_public_path__ + "img/bg-a.5a030c10.png";